import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.yellow,
  w = 67,
  h = 67,
}: { w: number; h: number } & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 52 52"
    >
      <rect
        data-name="Rectangle 1534"
        width="52"
        height="52"
        rx="4"
        fill={colors.darkGreen}
      />
      <g data-name="McD_GoldenArches® Logo">
        <path
          data-name="Path 1025"
          d="M23.456 0C20.573 0 18 4.036 16.318 10.35 14.634 4.036 12.061 0 9.178 0 4.11 0 0 13.433 0 30h4.08c0-15.386 2.284-27.858 5.1-27.858s5.1 11.514 5.1 25.716h4.08c0-14.2 2.284-25.716 5.1-25.716s5.1 12.472 5.1 27.858h4.077c-.003-16.567-4.113-30-9.181-30z"
          fill={color}
          transform="translate(9.684 11)"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
